import React from "react";
import { Doughnut } from "react-chartjs-2";
import { doughnutOptions } from "./_commonSharedChartOptions";
import { connect } from "react-redux";
import {
  WidgetLoading,
  WidgetNoDataToDisplay,
  WidgetServerError
} from "../../../../components/DashboardWidget/WidgetCommon";
import { uncompletedRequestsInTotalDataPreview } from "./_previewData";
const _ = require("lodash");

const widgetDetails = {
  Chart: "UNCOMPLETED_REQUESTS_IN_TOTAL_BY_PLATFORM",
  startDate: "05/18/2019%2012:00%20AM",
  endDate: "06/17/2019%2011:59%20PM",
  skillId: "amzn1.ask.skill.37a093eb-f18b-400a-bb88-388f1cc600d5"
};

class UncompletedReqInTotalContentClass extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { widgetData, draggable } = this.props;
    return (
      <div>
        <div className="widgetTitle">Uncompleted Requests</div>
        <div className="widgetTitleDescription">Number of uncompleted requests in total</div>
        <div className="widgetBody">
          {this.props.widgetData /*&& !this.state.loading*/ ? (
            widgetData.code !== 200 || draggable ? (
              <WidgetServerError draggable={draggable} />
            ) : widgetData.chart_data.data.length === 0 || draggable ? (
              <WidgetNoDataToDisplay draggable={draggable} />
            ) : (
              <Doughnut
                id={widgetDetails.Chart}
                data={{
                  labels: this.props.widgetData.chart_data.labels,
                  datasets: [
                    {
                      data: this.props.widgetData.chart_data.data,
                      backgroundColor: this.props.widgetData.chart_data.backgroundColor
                    }
                  ]
                }}
                options={doughnutOptions}
              />
            )
          ) : (
            <WidgetLoading />
          )}
        </div>
      </div>
    );
  }
}

export class UncompletedReqInTotalPreview extends React.Component {
  render() {
    return (
      <div>
        <div className="widgetTitle">Uncompleted Requests</div>
        <div className="widgetBody">
          <Doughnut
            id={widgetDetails.Chart}
            data={uncompletedRequestsInTotalDataPreview}
            options={_.merge({}, doughnutOptions, {
              legend: {
                labels: {
                  boxWidth: 5,
                  fontSize: 8,
                  padding: 2.5
                }
              },
              plugins: {
                datalabels: {
                  font: {
                    size: 7
                  }
                }
              }
            })}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    widgetData: state.dashboard[widgetDetails.Chart],
    dashboardDates: state.dashboard.widgetFromToDate,
    skill: state.skill
  };
}

export const UncompletedReqInTotalContent = connect(
  mapStateToProps,
  undefined
)(UncompletedReqInTotalContentClass);
